import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
 
 
  box-sizing: border-box;
  width:60%;
  margin: 0 auto;
  padding:5% 0% 5% 0%;



  @media (max-width: 500px) {
    width:90%;
    padding: 0%;
  }
`;


const Title = styled.h2`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 70px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  
  


  span{
    color: #FFF56A;
  }

  @media (max-width: 500px) {
    width:70%;
    font-size: 32px;
    line-height: 40px;
    padding:20% 0% 10% 0%;
    margin: 0 auto;

  }


`;

const GoalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 90px;
  flex-wrap: wrap;
  position: relative; 
  border-bottom: 1px solid #3F3F3F;

  @media (max-width: 500px) {
    flex-direction: row; 
    gap: 8px;
    border-bottom: 0px;


  }
`;

const GoalCard = styled.div`
  position: relative;
  flex: 1;
  max-width: calc(33% - 2px);
  background-color: transparent;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  
  
  overflow: hidden;
  margin-bottom: 24px;

  h1 {
    font-weight: 900;
    font-size: 64px;
    line-height: 75px;
    text-align: center;
    color: #333333;
    margin-bottom: 0px;
  }



  @media (max-width: 500px) {
    box-sizing: border-box;
    flex: calc(100% - 0px);
    max-width: 100%;
    margin-bottom: 8px; 

    h1 {
      font-size: 48px;
      line-height: 56px;
      margin-top: 0px;
    }
 
  }




`;



const GoalImage = styled.img`
  max-width: 80%;
  height: auto;
  object-fit: cover;
  border:20px solid #333333;
  background: #333333;
  border-radius: 30px;


  

  @media (max-width: 500px) {
   
    max-width: 80%; /* 調整圖片最大寬度 */
    border:10px solid #333333;
    height: auto; /* 確保高度按比例縮放 */
    padding:2.5% 2.5% 2.5% 2.5%;
    margin-left:0%;


  }
`;

const GoalTitle = styled.h2`
  
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  padding: 5% 0% 0% 0%;

  margin-top:5%;
  margin-bottom:5%;


  @media (max-width: 500px) {
    width:90%;
    font-size: 32px;
    line-height: 40px;
    padding:5% 0% 0% 0%;
    margin: 0 auto;
    text-align:center;

  }


`;


const GoalText = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  color: #AFAFAF;
  align-items: center;
  padding: 0% 0% 0% 0%;
  gap: 8px;
  margin-bottom: 16px;
  margin-top:0px;
  position: relative; 


  @media (max-width: 500px) {
    text-align:center;
    width:90%;
    font-size: 14px;
    padding:0% 5% 5% 5%;
    gap: 0px;
    line-height: 24px;
    margin-top:10px;
 
  }



`;

const Footer = styled.div`
  

    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-left: 2.5%; 
    margin-top: 0%; 
    gap:20px;

    a{
      text-decoration: none;
    }

    p{
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;
      
      letter-spacing: 0.05em;

      color: #FFFFFF;
    }

    @media (max-width: 500px) {
      display:none;
    
    }



`;

const ReadMoreButton = styled.button`
  background-color: #000000;
  color: #FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin: 0 auto;
  



  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top: 24px;
    padding: 6px 20px;
    margin: 0 auto;
  }

  &:hover {
    background-color: #FFFFFF;
    color: #1f1f1f;
  }
`;




const Web3Section4 = () => (
  <SectionWrapper>
    
    <Title>未來應用案例<span>.</span></Title>
    <GoalContainer>
      {/* Goal 1 */}
      <GoalCard>
        <h1>1</h1>
        <GoalImage src="/images/Web3Sec4_1.jpg" alt="Goal 1" />
        <GoalTitle>河流關係身分<br/>River Relational Identity</GoalTitle>
        <GoalText>透過我們與河流生態系統的相互關係的視角，理解和建構多元生態系間重要身分組成，不僅僅是從環境科學，包括基於文化和關愛關係的友善視角，以此形塑公民與生態系統的可持續發展。<br/>Understanding and making sense of the river's identity beyond environmental science, through the lens of our mutual relationships with the river ecosystem.</GoalText>
        
       
      </GoalCard>

      {/* Goal 2 */}
      <GoalCard>
        <h1>2</h1>
        <GoalImage src="/images/Web3Sec4_2.jpg" alt="Goal 2" />
        <GoalTitle>創新生活場景的多樣組合-實境分散式許可<br/>P2P Permissioning of Living Environments</GoalTitle>
        <GoalText>探索分散式公民建設的基礎，重新想像我們如何在更廣泛可行的商議模式下，幫助多樣性的價值延伸，建構對生活環境的共同信任，形塑實境生活場景的互惠交換與支付應用價值。<br/>A decentralised way of shaping the potential of the living environment through individual preference signalling and token exchange.</GoalText>
     
      </GoalCard>

      {/* Goal 3 */}
      <GoalCard>
        <h1>3</h1>
        <GoalImage src="/images/Web3Sec4_3.jpg" alt="Goal 3" />
        <GoalTitle>為集體意義建構提供知識溯源<br/>Knowledge Provenance for Collective Sense-making</GoalTitle>
        <GoalText>使用可驗證的知識溯源技術，發展可信、安全分享的資訊共通情境，在新聞媒體中建構可信任脈絡，作為社會共同意義建構的基礎。<br/>Using verifiable knowledge provenance to encourage more information sharing and to build trust in news media as society’s shared sense-making.</GoalText>
   
      </GoalCard>

  
    </GoalContainer>
    <Footer>
  
      <a href="https://drive.google.com/file/d/1ejgn3uVGewD0OFaEBdGiACYQxT8YkcbE/view?usp=drive_link" target="_blank" style={{ textDecoration: 'none' }}><ReadMoreButton>中文版</ReadMoreButton></a>
      <p>更多內容請見 web3 發展建議報告書</p>
      <a href="https://www.radicalxchange.org/media/" target="_blank" style={{ textDecoration: 'none' }}><ReadMoreButton>English</ReadMoreButton></a>

    </Footer>
  </SectionWrapper>
);

export default Web3Section4;
